<template>
<div>
  <q-dialog  v-model="modalInformativo" persistent
    >
      <q-card style="width: 700px; max-width: 80vw;">
        <q-card-section>
          <div class="text-h6 text-center text-primary">Informativo</div>
        </q-card-section>

        <q-card-section>
          <div class="text-h6 text-justify">{{mensagemModal}}</div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="Fechar" @click="closeModalInformativo" />
        </q-card-actions>
      </q-card>
    </q-dialog>
</div>
</template>

<script>
export default {
  data () {
    return {
      mensagemModal: 'O Banco da Amazônia esclarece que as condições e opções de pagamento apresentadas a seguir tem caráter ' +
      'apenas informativo, considerando que, caso aceita, a proposta é para que o acordo seja celebrado no bojo das ações judiciais ' +
      'coletivas hoje em curso, e que, quanto aos valores apresentados, o pagamento restará condicionado à confirmação final dos ' +
      'dados cadastrais.'
    }
  },
  props: {
    modalInformativo: Boolean
  },
  methods: {
    closeModalInformativo () {
      this.$emit('closeModalInformativo', false)
    }
  }
}

</script>
